var React = require('react');

function TextWidth (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 48v80a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-16H264v112h24a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H160a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h24V112H64v16a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h416a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M443.31 372.69a16 16 0 0 1 0 22.62l-80 80c-10 10-27.31 3-27.31-11.31v-48H112v48c0 15.64-18 20.64-27.31 11.31l-80-80a16 16 0 0 1 0-22.62l80-80c10-10 27.31-3 27.31 11.31v48h224v-48c0-15.64 18-20.64 27.31-11.31z","className":"fa-primary","key":2})]);
}

TextWidth.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = TextWidth;

TextWidth.default = TextWidth;
